import React from "react";
import { Link } from "react-router-dom";
import blogPosts from "../data/blogPosts.json";
import SEO from "../components/SEO.jsx";
import PageHero from "../components/page/PageHero.jsx";

export default function Blog() {
  return (
    <>
      <SEO
        title="Blog | 2merative Web Design"
        description="Latest articles on small business websites, SEO, performance, and growth systems—written for owners who want results, not jargon."
        path="/blog"
        image="/og-image.png"
      />

      <PageHero eyebrow="Insights" title="Latest Articles" showCtas={false} />

      <div className="px-4 pt-14 pb-16 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogPosts.map((post) => (
          <div
            key={post.id}
            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300"
          >
            <Link to={`/blog/${post.slug}`}>
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover"
                loading="lazy"
              />
            </Link>

            <div className="p-5 flex flex-col justify-between h-full">
              <div>
                <h2 className="text-xl font-semibold mb-1 text-gray-800">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>

                <p className="text-sm text-gray-500 mb-3">
                  {new Date(post.date).toLocaleDateString("en-AU", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                    timeZone: "Australia/Adelaide",
                  })}
                </p>

                <p className="text-gray-700 text-sm mb-4">{post.summary}</p>
              </div>

              <Link
                to={`/blog/${post.slug}`}
                className="text-sm font-medium text-blue-600 hover:underline mt-auto"
              >
                Read More →
              </Link>
            </div>
          </div>
        ))}
      </div>
      </div>
    </>
  );
}
